import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export default class AreaAttendanceOnline extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return ((
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ===
				AttendanceFilterOptionValue.ONLINE &&
			(await this.singleSelectionFor(FilterKey.AREA, filterSelectionState)) &&
			(this.selectionTypeCount(filterSelectionState) === 2 ||
				(this.selectionTypeCount(filterSelectionState) === 3 &&
					this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState))))
		);
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);
		const portalName = degree.toPortalName();

		const seoInfo = {
			title: `Complete list of online universities in ${area} | ${portalName}`,

			description:
				`Find which universities in ${area} you can study online at. ` +
				`Filter by discipline and more to find ` +
				`the perfect university for you to study online.`,
		};

		return Promise.resolve(seoInfo);
	}
}
